import { render, staticRenderFns } from "./SetBudgetDialog.vue?vue&type=template&id=78a5e919&"
import script from "./SetBudgetDialog.vue?vue&type=script&lang=js&"
export * from "./SetBudgetDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports